module.exports = __webpack_public_path__ + "static/reducedtransparency-4fd9dec3043385b5173588dfaaf9e243.png";